import { LoginForm } from '@/components/auth/LoginForm';
import { MfaVerificationForm } from '@/components/auth/MfaForm';
import { SetupMfaPage } from '@/components/auth/SetupMfaPage';
import { ChangePasswordForm } from '@/components/auth/ChangePasswordForm';
import { useAppSelector } from '@/app/store';
import { selectAuth } from '@/app/features/authSlice';
import { Navigate } from 'react-router';

export default function LoginPage() {
  const { isAuthenticated, authStep } = useAppSelector(selectAuth);

  if (isAuthenticated && !authStep) {
    return <Navigate to="/dashboard" replace />;
  }

  if (authStep === 'mfa') {
    return <MfaVerificationForm />;
  }

  if (authStep === 'changePassword') {
    return <ChangePasswordForm />;
  }

  if (authStep === 'setupMfa') {
    return <SetupMfaPage />;
  }

  return <LoginForm />;
}
